export class AuditSummaryFollowupRequest {
    public FileName: string = "";
    public FileID: string = "";
    public AssistantID: string = "";
    public Question: string = "";
    constructor(values: Object = {}){
        Object.assign(this, values);     
    }
}